import React,{useContext} from "react"
import { Typography, MenuItem } from "@material-ui/core"
import {BetterControlledTextField, ControlledTextField} from "../../Core/Form/ControlledFields";
import { STATES } from "../../../Constants";
import { useFormContext } from "react-hook-form";
import { QuoteContextStore } from '../../../context/QuoteContext/QuoteContext';

const AirportStateSelect = () => {
    const {setValue} = useFormContext();
    const {locked_quote} = useContext(QuoteContextStore)

    const handleOnChange = () => {
        setValue("city", "");
        setValue("name", "");
    }

    return (<>
            <Typography variant="h4" className="gray">Airport state</Typography>
            <BetterControlledTextField fullWidth onChange={handleOnChange} name="state" className="margin-top-8" select placeholder="State" disabled={locked_quote}>
                    <MenuItem selected disabled value="default" className="gray"><span className="placeholder-gray">State</span></MenuItem>
                    {Object.keys(STATES).map(name => <MenuItem value={name} key={name}>{STATES[name]}</MenuItem>)}
            </BetterControlledTextField>
    </>)
}

export default AirportStateSelect;